"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnIntegVolt = void 0;
const base_1 = require("./base");
const volt_1 = require("../services/volt");
/**
 * Voltage Pixel
 */
class AnIntegVolt extends base_1.AnIntegBase {
    static sendTrackClubThankyou(siteCategory, userId, email, price, style, color, coupon) {
        volt_1.AnServVolt.sendCustEvent(this.getPixelId("club"), "Order Confirmation Page", {
            // User Id
            tid: userId.toString(),
            // Quantity of Items
            cnt: "1",
            // Price of items
            val: price.toString(),
            // New Customer (0) or Returning Customer (1)
            ret: "0",
            // Style
            custom0: style,
            // Color
            custom1: color,
        });
        return true;
    }
    static sendTrackClubThankyouLegacy(siteCategory, userId, email, price, style, color, coupon) {
        return this.sendTrackClubThankyou(siteCategory, userId, email, price, style, color, coupon);
    }
    static sendTrackClubRejoinLegacy(siteCategory, userId, email, price) {
        volt_1.AnServVolt.sendCustEvent(this.getPixelId(siteCategory), "Win Back Conversion", {
            // User Id
            tid: userId.toString(),
            // Quantity of Items
            cnt: "1",
            // Price of items
            val: price.toString(),
            // New Customer (0) or Returning Customer (1)
            ret: "1",
        });
        return true;
    }
    static sendTrackEcommThankyou(siteCategory, userId, orderId, price, coupon) {
        volt_1.AnServVolt.sendCustEvent(this.getPixelId(siteCategory), "ecommerce shop", {
            // Order Id
            tid: orderId.toString(),
            // Quantity of Items
            cnt: "1",
            // Price of Items
            val: price.toString(),
            // New Customer (0) or Returning Customer (1)
            ret: "0",
        });
        return true;
    }
}
exports.AnIntegVolt = AnIntegVolt;
AnIntegVolt.shouldSendTrackClubThankyou = true;
AnIntegVolt.shouldSendTrackClubThankyouLegacy = true;
AnIntegVolt.shouldSendTrackEcommThankyou = true;
AnIntegVolt.shouldSendTrackClubRejoinLegacy = false;
AnIntegVolt.pixelId = {
    prod: {
        defaultId: "452",
        ecomm: null,
        club: null,
    },
    dev: {
        defaultId: "452",
        ecomm: null,
        club: null,
    },
};
